import * as yup from "yup";

// ASCII printable characters validation (characters 32-126, space to tilde)
const ASCII_PRINTABLE_REGEX = /^[\x20-\x7E]*$/;

// Define the form data type first
export interface InviteAdminUserFormData {
  email: string;
  firstName: string;
  middleName?: string;
  lastName: string;
}

// Admin user invitation validation schema with proper typing
export const inviteAdminUserSchema: yup.ObjectSchema<InviteAdminUserFormData> =
  yup.object().shape({
    email: yup
      .string()
      .required("Email address is required")
      .email("Must be a valid email")
      .max(255, "Email must be 255 characters or less"),

    firstName: yup
      .string()
      .required("First name is required")
      .max(64, "First name must not exceed 64 characters")
      .matches(
        ASCII_PRINTABLE_REGEX,
        "First name must contain only ASCII printable characters",
      ),

    middleName: yup
      .string()
      .max(64, "Middle name must not exceed 64 characters")
      .matches(
        ASCII_PRINTABLE_REGEX,
        "Middle name must contain only ASCII printable characters",
      )
      .optional(),

    lastName: yup
      .string()
      .required("Last name is required")
      .max(64, "Last name must not exceed 64 characters")
      .matches(
        ASCII_PRINTABLE_REGEX,
        "Last name must contain only ASCII printable characters",
      ),
  });

export const adminProfileSchema = yup.object().shape({
  id: yup.string().required("Account ID is required"),
  email: yup
    .string()
    .email("Please enter a valid email address")
    .required("Email is required"),
  avatar: yup.mixed().nullable().notRequired(),
  firstName: yup
    .string()
    .required("First name is required")
    .max(64, "First name cannot exceed 64 characters")
    .matches(
      ASCII_PRINTABLE_REGEX,
      "First name can only contain ASCII printable characters",
    ),
  middleName: yup
    .string()
    .max(64, "Middle name cannot exceed 64 characters")
    .matches(
      ASCII_PRINTABLE_REGEX,
      "Middle name can only contain ASCII printable characters",
    )
    .nullable()
    .notRequired(),
  lastName: yup
    .string()
    .required("Last name is required")
    .max(64, "Last name cannot exceed 64 characters")
    .matches(
      ASCII_PRINTABLE_REGEX,
      "Last name can only contain ASCII printable characters",
    ),
  phone: yup
    .string()
    .matches(/^[+]?[\d\s\-()]*$/, "Please enter a valid phone number")
    .nullable()
    .notRequired(),
});

// Infer the type from the schema
export type AdminProfileFormData = yup.InferType<typeof adminProfileSchema>;
